import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withKeys as _withKeys, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02642ad2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-page" }
const _hoisted_2 = { class: "auth-page__wrapper" }
const _hoisted_3 = { class: "auth-page__card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "auth-page__title" }, " Create your account ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth-page__subtitle" }, " Start tracking your productivity today ", -1))
const _hoisted_6 = {
  key: 0,
  class: "auth-page__error"
}
const _hoisted_7 = { class: "auth-page__footer" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "auth-page__footer-text" }, " Already have an account? ", -1))

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import useQuasar from 'quasar/src/composables/use-quasar.js';;

import DSTextField from '@/design-system/DSTextField.vue';
import DSButton from '@/design-system/DSButton.vue';

import { api } from '@/libs/api';
import { jwt } from '@/static/storage-keys';


export default /*#__PURE__*/_defineComponent({
  __name: 'DCRegister',
  setup(__props) {

const router = useRouter();
const $q = useQuasar();

const name = ref('');
const email = ref('');
const password = ref('');
const confirm_password = ref('');
const error = ref('');
const request_pending = ref(false);

const handleLogin = async() => {
  const body = {
    name: name.value,
    email: email.value,
    password: password.value,
    confirm_password: confirm_password.value,
  };

  request_pending.value = true;
  const { id, message } = await api.post('/register', body);
  request_pending.value = false;

  if (id) {
    const { token } = await api.post('/login', { email: email.value, password: password.value });

    if (token) {
      $q.notify({
        progress: true,
        type: 'positive',
        message: 'Registration completed successfully!',
        icon: 'done',
        position: 'top-right',
      });

      $q.cookies.set(jwt, token, { expires: '7d' });
      return router.push({ path: '/' });
    }
  }

  error.value = message;

  return $q.notify({
    progress: true,
    type: 'negative',
    message: 'Registration failed.',
    icon: 'error_outline',
    position: 'top-right',
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("form", {
          onSubmit: handleLogin,
          class: "auth-page__form"
        }, [
          _createVNode(DSTextField, {
            modelValue: name.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((name).value = $event)),
            label: "Full Name",
            placeholder: "Enter your name",
            icon: "person",
            type: "text",
            autocomplete: "name",
            "aria-label": "Name"
          }, null, 8, ["modelValue"]),
          _createVNode(DSTextField, {
            modelValue: email.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((email).value = $event)),
            label: "Email",
            placeholder: "Enter your email",
            icon: "email",
            type: "email",
            autocomplete: "email",
            "aria-label": "Email"
          }, null, 8, ["modelValue"]),
          _createVNode(DSTextField, {
            modelValue: password.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((password).value = $event)),
            label: "Password",
            placeholder: "Create a password",
            icon: "lock",
            type: "password",
            autocomplete: "new-password",
            onKeyup: _withKeys(handleLogin, ["enter"]),
            "aria-label": "Password"
          }, null, 8, ["modelValue", "onKeyup"]),
          _createVNode(DSTextField, {
            modelValue: confirm_password.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((confirm_password).value = $event)),
            label: "Confirm Password",
            placeholder: "Confirm your password",
            icon: "lock",
            type: "password",
            autocomplete: "new-password",
            onKeyup: _withKeys(handleLogin, ["enter"]),
            "aria-label": "Confirm password"
          }, null, 8, ["modelValue", "onKeyup"]),
          (!! error.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(error.value), 1))
            : _createCommentVNode("", true),
          _createVNode(DSButton, {
            type: "submit",
            label: "Create account",
            icon: "person_add",
            loading: request_pending.value,
            variant: "primary",
            class: "auth-page__submit"
          }, null, 8, ["loading"])
        ], 32),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_router_link, {
            to: { name: 'login' },
            class: "auth-page__link"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Sign in ")
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})